import { WidgetFeature } from 'enums/WidgetFeature';
import { FeaturesMap } from 'interfaces/FeatureMap';

export const defaultFeatures: FeaturesMap = {
    [WidgetFeature.InformationBanner]: true,
    [WidgetFeature.FuzzySearch]: true,
    [WidgetFeature.MultiUploads]: true,
    [WidgetFeature.WaitingGame]: true,
    [WidgetFeature.WaitingGameHiScore]: true,
    [WidgetFeature.WaitingGameEncryptedScore]: true,
    [WidgetFeature.EmptyHistoryScreen]: true,
    [WidgetFeature.Favorites]: true,
    [WidgetFeature.AdAuth]: false,
    [WidgetFeature.FaviconIndicator]: true,
    [WidgetFeature.BrowserNotifications]: true,
    [WidgetFeature.MaximizeMinimize]: true,
    [WidgetFeature.LimitUnauthorizedFeatures]: true,
    [WidgetFeature.HistoryDumpTxt]: true,
    [WidgetFeature.HistoryDumpHtml]: true,
    [WidgetFeature.ErrorScreen]: true,
    [WidgetFeature.ColorSchemes]: true,
    [WidgetFeature.BotReplyLoader]: true,
    [WidgetFeature.MediaGallery]: true,
    [WidgetFeature.CaptureOtp]: true,
    [WidgetFeature.PredictiveInput]: true,
    [WidgetFeature.VoiceRecorder]: true,
    [WidgetFeature.VoiceGallery]: false, // TODO should be `true` by default
    [WidgetFeature.SendFingerPrint]: true,
    [WidgetFeature.DionVideo]: true,
    [WidgetFeature.PreventClosing]: false,
    [WidgetFeature.OperatorWaitingTimer]: '600', // [0 -> off], [>0 -> on]
    [WidgetFeature.WidgetTabs]: false, // TODO should be `true` by default
    [WidgetFeature.IosGestures]: true,
    [WidgetFeature.LogToClipboard]: true,
    [WidgetFeature.LogToDiv]: false,
    [WidgetFeature.PassPhraseListener]: false,
    [WidgetFeature.UseHistoryAPI]: true,
    [WidgetFeature.QuickActionsMenuScrollAnimation]: false,
    [WidgetFeature.ForceAstromAnalytics]: true,
    [WidgetFeature.ReconnectOnTimeout]: true,
};
